import classNames from 'classnames'
import React, { useCallback, useState } from 'react'

import Minus from 'assets/images/icons/minus-icon-blue.svg'
import Plus from 'assets/images/icons/plus.svg'

import STYLES from './Accordion.module.sass'

import Text, { TextProps } from '../Text'

type AccordionProps = {
  title: TextProps
  children: React.ReactNode
  onToggle?: (isOpen: boolean) => void
}

const Accordion = ({
  title,
  children,
  onToggle
}: AccordionProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = useCallback(() => {
    setIsOpen((prev) => !prev)

    if (onToggle) {
      onToggle(isOpen)
    }
  }, [onToggle, isOpen])

  const accordionContentClass = classNames(STYLES.accordionContent, {
    [STYLES.isOpen]: isOpen
  })

  return (
    <div data-testid="accordion" className={STYLES.accordion}>
      <button
        type="button"
        onClick={handleToggle}
        className={STYLES.accordionHeader}
      >
        <Text variant="display18" margin={false} {...title} />

        <img src={isOpen ? Minus : Plus} width="20" alt="Toggle modal" />
      </button>

      <div className={accordionContentClass}>{children}</div>
    </div>
  )
}

export default Accordion
